import { Injectable } from '@angular/core';
import { GridDataService } from '../../base-data-services/grid-data.service';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_URL, ASSIGNMENT_GRID_URL } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import {
  GridParams,
  GridPostParams,
} from 'common/models/utility-models/list-utility.model';

import { TrainersModel } from 'common/models/page-models/Trainers Model/trainers-data.model';
import { TrainersListingModel, TrainersGridParams } from 'common/models/page-models/Trainers Model/trainers-params.model';
import { BranchCategoryGridPostParams } from 'common/models/page-models/branch-category/branch-category-grid.model';




@Injectable({
  providedIn: 'root',
})
export class TrainersGridDataService extends GridDataService<
  TrainersListingModel,
  TrainersModel
> {
  constructor(http: SmApiService, protected override ss: SystemService) {
    super(API_URL.trainersGrid, http, ss);
  }

  createInstance(): TrainersListingModel {
    return new TrainersListingModel();
  }

  override getDeleteUrl(): string {
    return '';
  }

  override getGridParams(param): GridPostParams {
    return new TrainersGridParams();
  }


  override getStatusUrl(): string {
    return '/trainerList/save';
  }

  override getStatusPayload(data): any {
    let payload;
    
    payload = { id: data.id, status: data.status === 1 ? 2 : 1 };
    // console.log(payload)
    return payload;
  }

  // override transformDataModel(data: any[], param) {
  //   super.transformDataModel(data, param);

  //   this.setSystemServiceData(
  //     'category_name',
  //     ASSIGNMENT_GRID_URL.getCatList,
  //     new BranchCategoryGridPostParams(),
  //     'details'
      
  //   );
  //   return data;
  // }


}
